import Buggy from '@alltrails/shared/icons/Buggy';
import Icy from '@alltrails/shared/icons/Icy';
import Muddy from '@alltrails/shared/icons/Muddy';
import Slippery from '@alltrails/shared/icons/Slippery';
import Snowy from '@alltrails/shared/icons/Snowy';
import { TrailConditionUid } from 'types/Trails/TrailCondition';

type TrailConditionsIconProps = {
  trailConditionUid: TrailConditionUid;
};

const TrailConditionsIcon = ({ trailConditionUid }: TrailConditionsIconProps): JSX.Element => {
  switch (trailConditionUid) {
    case TrailConditionUid.Buggy:
      return <Buggy />;
    case TrailConditionUid.Icy:
      return <Icy />;
    case TrailConditionUid.Muddy:
      return <Muddy />;
    case TrailConditionUid.Slippery:
      return <Slippery />;
    case TrailConditionUid.Snowy:
      return <Snowy />;
    default:
      return null; // leave the icon empty
  }
};

export default TrailConditionsIcon;
